import React, { FC, ReactElement } from 'react';
import {RankingCard} from "./RankingCard";

interface Props {
    defaultFilters?: { [key: string]: (string | number | string[] | number []) },
    attemptId: string;
}

export const AttemptRankingCard: FC<Props> = ({defaultFilters, attemptId}): ReactElement => {
    return (
        <RankingCard
            url={`/reports/student-exercise-attempts/${attemptId}/ranking`}
            defaultFilters={defaultFilters}
            tooltip='Ranking of this attempt against all student attempts for this activity.'
        />
    );
};
